<template>
  <div>
  <div class="container">
    <div id="columnMain" class="mb-3">
      <div id="columnMainContent">
        <div v-if="textLang == 'en'">
          <div class="row">
            <div class="col-10">
              <h1>CZECH TRANSLATION OF THE QUR’AN MEANING PROJECT</h1>
            </div>
            <div class="col-2 text-right">
              <a @click="changeTextLang('cs')" style="cursor: pointer;"><img src="@/assets/images/flag-cs.png"></a>
            </div>
          </div>

          <div class="row">
            <div class="col" style="padding-left: 2rem; padding-right: 5rem;">
              <h2>Reasons and aims of the project</h2>
              <p>
                This project includes a new translation of the meaning of the Qur’an to the Czech language and its print. The last translation of the Qur’an has been finished more than 50 years ago and there are some factual errors and inaccuracies. That is why a group of active Czech and Slovak Muslims decided to start this project which will be a product of Muslims and not of orientalists.
              </p>


              <h2>Management Team</h2>
              <h4>Translators’ Group:</h4>
              <p class="px-3">
                <b>Sheikh Bc. Milan Váhala and Bc. Silvie Váhalová DiS.</b>
                <br>
                The manager of the team sheikh Váhala and his wife studied Arabic and Islam for 12 years in Egypt and Saudi Arabia, he is a graduate of the Islamic University in Medina and of postgraduate courses of well-known scholars.
              </p>

              <h4>Organization and support group:</h4>
              <p class="px-3">
                About 15 Muslims of the Czech or Slovak origin. Their task is mainly collecting financial sources during the project, to control the work on the project and to run a website (www.korancesky.cz) that has been established for this project. The core of this group has been active for several years already and organizes various events in the field of Islamic education, social and charity events for the benefit of the Muslim community especially in Prague, the capital of the Czech Republic.
              </p>


              <h2>Translation</h2>
              <p>
                Every single word of the Arabic original of the Qur’an is translated and controlled based on the below-mentioned sources, i.e. the word itself, the verse and then also the included tafsir (interpretation). There are no omissions of words of the original Qur’an written in Arabic except expressions that have no equivalent in Czech. In these cases the closest equivalent as far as the meaning is concerned existing in Czech is chosen.
              </p>

              <ul>
                <li>Al-Tabari</li>
                <li>Ibn Kathir</li>
                <li>As-Sa'di</li>
                <li>Al-Qurtubi</li>
                <li>Al-Shawkani</li>
                <li>Al-Bahr al-muhit</li>
                <li>Tafsir of the words of the Qur’an, Al-Azhar </li>
                <li>Summarized tafsir of a group of scientists of the KSA   </li>
                <li>Tafsir of the Qur’anic complex of the king Fahd, al-Madina</li>
                <li>and except these tafsirs also the Vocabulary of the terms of the Qur’an by dr. an-Nadwi</li>
              </ul>

              <h2>Transcription of Arabic words</h2>
              <p>Any Arabic terms and words in the translation itself or in the tafsir are subject to a defined transliteration table prepared by a transliteration team. Also, the names of the suras in Arabic are subject to the transliteration in accordance with the transliteration table.</p>

              <h2>Proofreading of the translation</h2>
              <p class="px-3">Any variance in the translation, in the meaning or in the used tafsir shall be presented for consultation to the translators’ group. Any changes in the contents of the text are subject to the approval of the translators’ group.</p>

              <p class="px-3">Nobody has the right to change the contents of the text without an approval of sheikh Milan Váhala. It does not apply to graphic, grammatical amendments or transliteration.
              </p>

              <p class="px-3">Váhala: „Even after our death we wish this work would serve Muslims in the Czech Republic and the whole Islamic umma. If only this work would be used for example as a basis for an extended detailed interpretation in Czech, inshallah.“</p>

              <p class="px-3">If future generations would amend this work it will be necessary to create a  team of specialists.</p>

              <h2>Name of the final work</h2>
              <p>Subject to the opinion of the majority of management team.</p>

              <h2>Copyright</h2>

              <p>
                The management team involved in the preparation of the new translation of the Qur’an, being it the text, the tafsir, graphics, website etc., donates the copyright and other rights connected with it to the Czech Muslim community by way of a waqf. Waqf means stopping, cessation or maintaining. In Islam, a Waqf is a voluntary, permanent, irrevocable donation of part of someone’s wealth – in cash or in kind – to Allah. The team undertakes to transfer the rights for an indefinite period of time to the Czech community. In case of need of reprint it means that this new translation of the meaning of the Qur’an is not subject to copyright of the translation group, organization group or support group.
                <br>
                Any profit connected with the use of the new translation of the Qur’an may be reinvested and the subsequent profit may be used for the production of other copies, for maintaining the project of the Qur’an or to other charity as needed. The profit may be also used directly for activities connected with maintaining the project of the Qur’an instead of for investment. The person responsible for the financial matters is the administrator of the waqf: the management team in co-operation with the Muslim Community in Prague.
              </p>

              <h2>Work Schedule</h2>
              <p>
              <ul>
                <li>The period planned for completing the translation is 7 to 8 years. That is less than three months for completing the translation of each single part („juzu“) – this period is the average, some suras are more difficult for translation and they will take more time to be translated. Some may be finished earlier.</li>
                <li>Preparation works for printing and the print should take another year.</li>
                <li>Website operation and continuing additions of the completed parts of the translation of the Qur’an to it.</li>
                <li>After completing the translation and printing it, the korancesky.cz website shall continue to be at public disposal.</li>
              </ul>
              </p>

              <h2>Cost of the project</h2>

              <table class="table">
                <thead class="thead-dark">
                <tr>
                  <th>Project stage</th>
                  <th>Period length</th>
                  <th>Minimum monthly cost</th>
                  <th>Total cost*</th>
                  <th>Total cost in USD**</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>1. Translation of the Qur’an</td>
                  <td>8 years</td>
                  <td>CZK 15,000</td>
                  <td>CZK 1,440,000</td>
                  <td>$63,730</td>
                </tr>
                <tr>
                  <td>2. Preparation of printing</td>
                  <td>6 months</td>
                  <td></td>
                  <td>CZK 60,000</td>
                  <td>$2,790</td>
                </tr>
                <tr>
                  <td>3. Print (2000 copies)</td>
                  <td>3 months</td>
                  <td></td>
                  <td>CZK 300,000</td>
                  <td>$13,953</td>
                </tr>
                <tr>
                  <td>4.a Website maintenance</td>
                  <td>Unlimited</td>
                  <td>CZK 550</td>
                  <td>CZK 52,800</td>
                  <td>$2,332</td>
                </tr>
                <tr>
                  <td>4.b Website development</td>
                  <td></td>
                  <td></td>
                  <td>CZK 37,800</td>
                  <td>$1,670</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th>9 years</th>
                  <th></th>
                  <th>CZK 1,890,600</th>
                  <th>$84,475</th>
                </tr>
                </tbody>
              </table>

              <p>
                <small>
                  *The total cost is calculated for the period of 9 years based on prices in 2021 and 2022.
                  <br>
                  **The exchange rate used for the table is CZK 22.63 = USD 1.00
                </small>
              </p>

              <p>
                For the purpose of collecting money for this project, a special transparent account (a public collection) has been established on behalf of the Muslim Community in Prague which is a religious society registered by the state.
              </p>

              <p>
              <form action="https://www.paypal.com/donate" method="post" target="_top">
                <input type="hidden" name="hosted_button_id" value="YFPFLVCNRBMSQ"/>
                <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button"/>
                <img alt="" border="0" src="https://www.paypal.com/en_CZ/i/scr/pixel.gif" width="1" height="1"/>
              </form>
              </p>

              <h2>Final notes</h2>
              <p>Concerning the translation of the meaning of the Qur’an, the contents shall take priority over the form provided that the form shall not be neglected in the translation unless it would affect the correct contents.</p>

              <p>The aim of the project is to translate the original Qur’an as correctly as possible and to express the correct contents of the message what Allah says in the original. That is why the translators will try to use clear contemporary Czech without archaic words, inshaallah. The sentences shall be accompanied by the included tafsir from authentic sources to make reading and comprehension of the text easier.</p>

              <p>Let Allah the Almighty bless anyone who will make a contribution to this project that shall be used for the needs of the growing Czech speaking Muslim community and also of Non-Muslims and people interested in Islam. Anyone who contributes to this work seeks the favour of Allah and shall be rewarded for it and the reward shall last as long as this Qur’an is used for studying and inshaallah it will bring many people to Islam. It is sadaqa jaria (permanent charity). Let us wish success to ourselves and say dua. Inshaallah, our work shall be blessed by our Creator.</p>

              <p>Assalamu alaikum,</p>

              <p>the Management Team.</p>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="row">
            <div class="col-10">
              <h1>PROJEKT PŘEKLADU VÝZNAMU KORÁNU DO JAZYKA ČESKÉHO</h1>
            </div>
            <div class="col-2 text-right">
              <a @click="changeTextLang('en')" style="cursor: pointer;"><img src="@/assets/images/flag-uk.png"></a>
            </div>
          </div>

          <div class="row">
            <div class="col" style="padding-left: 2rem; padding-right: 5rem;">
              <h2>Důvody a cíl projektu</h2>
              <p>
                Tento projekt zahrnuje nový překlad významu Koránu do českého jazyka a jeho tisk. Poslední překlad Koránu do češtiny byl dokončen před více než 50 lety a vyskytují se v něm některé faktické chyby a nepřesnosti. Proto se skupina aktivních českých a slovenských muslimů rozhodla zahájit tento projekt, který bude dílem muslimů, nikoliv orientalistů.
              </p>


              <h2>Realizační tým</h2>
              <h4>Překladatelská skupina:</h4>
              <p class="px-3">
                <b>Šejch Bc. Milan Váhala a Bc. Silvie Váhalová DiS.</b>
                <br>
                Vedoucí týmu šejch Váhala i se svou manželkou 12 let studoval arabštinu a islám v Egyptě a Saudské Arábii, je absolventem islámské univerzity v Medíně a postgraduálních kurzů u známých učenců.
              </p>

              <h4>Organizační a podpůrná skupina:</h4>
              <p class="px-3">
                Přibližně 15 muslimů českého nebo slovenského původu. Úkolem skupiny bude především shromažďovat finanční prostředky po celou dobu projektu, kontrolovat práce na projektu a provozovat webové stránky www.korancesky.cz, které byly pro tento projekt založeny. Jádro této skupiny je aktivní už několik let a pořádá různé aktivity v oblasti islámské osvěty, společenské a charitativní akce ve prospěch muslimské komunity, především v Praze, hlavním městě ČR.
              </p>


              <h2>Překlad</h2>
              <p>
                Každé jedno slovo z arabského originálu Koránu je překládáno a kontrolováno všemi níže jmenovanými zdroji, tj. samotné slovo, verš a následně i vložený tafsír (výklad). Nejsou vynechána žádná slova z původního Koránu psaného v arabštině, kromě výrazů, pro které není v češtině odpovídající výraz. V těchto případech je volen významově nejbližší ekvivalent existující v českém jazyce.
              </p>

              <ul>
                <li>At-Tabarí</li>
                <li>Ibn Kathír</li>
                <li>As-Sa'dí</li>
                <li>Al-Qurtubí</li>
                <li>Aš-Šawkání</li>
                <li>Al-Bahru l-muhít </li>
                <li>Tafsír slov Koránu Al-Azhar </li>
                <li>Sumarizovaný tafsír skupiny vědců KSA   </li>
                <li>Tafsír Koránského komplexu krále Fahda Al-Madína </li>
                <li>a mimo tyto tafsíry Slovník termínů Koránu dr. An-Nadví.</li>
              </ul>

              <h2>Přepis arabských slov</h2>
              <p>Jakékoliv arabské termíny a slova v samotném překladu nebo tafsíru podléhají ustanovené transliterační tabulce připravené transliteračním týmem. Rovněž jména súr v arabštině podléhají přepisu dle transliterační tabulky.</p>

              <h2>Korektury překladu</h2>
              <p class="px-3">Případná neshoda v překladu, ve významu nebo v použitém tafsíru bude směrována ke konzultaci překladatelské skupině. Jakékoliv změny v obsahu textu podléhají schválení vedoucím překladatelské skupiny.</p>

              <p class="px-3">Nikdo nemá právo měnit obsah textu bez schválení šejchem Milanem Váhalou. Netýká se to grafických, gramatických uprav a ani transliterace.
              </p>

              <p class="px-3">Váhala: „I po naší smrti si přejeme, ať toto dílo je ku prospěchu muslimů České republiky a celé islámské ummy. Kéž je toto dílo např. použito jako základ pro rozšířený, podrobný výklad v češtině inšéAlláh.“</p>

              <p class="px-3">Budou-li budoucí generace upravovat toto dílo, bude nutné vytvořit odborný tým.</p>

              <h2>Název výsledného díla</h2>
              <p>Podléhá většinovému názoru realizačnímu týmu.</p>

              <h2>Autorská práva</h2>

              <p>
                Realizační tým podílející se na přípravě nového překladu Koránu, ať to je text, komentář, grafika, web atd., (dále jen „Tým“) věnuje autorská a další práva s tímto spojená české muslimské komunitě formou waqfu. Waqf znamená zastavení, zadržení nebo uchování. V Islámu je Waqf dobrovolné, trvalé, neodvolatelné věnování části něčího bohatství – v hotovosti nebo v naturáliích – Alláhovi. Tým se zavazuje převést práva na dobu neurčitou české komunitě. Po vzniku potřeby dotisku to tedy znamená, že tento nový překlad významu Koránu nepodléhá autorským právům překladatelské ani organizační a podpůrné skupiny.
                <br>
                Jakýkoliv výtěžek spojený s použitím nového překladu Koránu může být dále investován a následný výtěžek použit k produkci dalších výtisků, udržení projektu Koránu, nebo jinou dobročinnost dle nutnosti. Výtěžek může být také místo investice použit přímo na aktivity spojené s udržením projektu Koránu. O těchto finančních záležitostech rozhoduje správce waqfu: Realizační tým ve spolupráci s Muslimskou obci v Praze.
              </p>

              <h2>Harmonogram prací</h2>
              <p>
              <ul>
                <li>Plánovaná doba na dokončení překladu je 7 až 8 let. To odpovídá necelým třem měsícům na dokončení překladu každého jednoho džuz´u – tato doba je průměrná, některé súry jsou na překlad obtížnější a jejich překlad bude trvat déle. Jiné mohou být přeloženy rychleji.</li>
                <li>Další jeden rok by měly trvat přípravné práce k tisku a tisk.</li>
                <li>Provoz a průběžné doplňování webových stránek dokončenými částmi překladu Koránu.</li>
                <li>Po dokončení překladu a vytištění, bude web korancesky.cz nadále k dispozici veřejnosti.</li>
              </ul>
              </p>

              <h2>Finanční náklady na projekt</h2>

              <table class="table">
                <thead class="thead-dark">
                <tr>
                  <th>Fáze projektu</th>
                  <th>Doba trvání</th>
                  <th>Minimální měsíční náklady</th>
                  <th>Celkové náklady*</th>
                  <th>Celkové náklady v USD**</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>1. Překlad Koránu</td>
                  <td>8 let</td>
                  <td>15 000 Kč</td>
                  <td>1 440 000 Kč</td>
                  <td>$63 730</td>
                </tr>
                <tr>
                  <td>2. Příprava k tisku</td>
                  <td>6 měsíců</td>
                  <td></td>
                  <td>60 000 Kč</td>
                  <td>$2 790</td>
                </tr>
                <tr>
                  <td>3. Tisk (2000 výtisků)</td>
                  <td>3 měsíce</td>
                  <td></td>
                  <td>300 000 Kč</td>
                  <td>$13 953</td>
                </tr>
                <tr>
                  <td>4.a Provoz webu </td>
                  <td>Neurčito</td>
                  <td>550 Kč</td>
                  <td>52 800 Kč</td>
                  <td>$2 332</td>
                </tr>
                <tr>
                  <td>4.b Dokončení webu</td>
                  <td></td>
                  <td></td>
                  <td>37 800 Kč</td>
                  <td>$1 670</td>
                </tr>
                <tr>
                  <th>Celkem</th>
                  <th>9 let</th>
                  <th></th>
                  <th>1 890 600 Kč</th>
                  <th>$84 475 </th>
                </tr>
                </tbody>
              </table>

              <p>
              <small>
                *celkové náklady jsou na uvedeny na 9leté období na základě cen v letech 2021 a 2022
                <br>
                **kurz přepočtu použitý pro tabulku je 22,63 Kč = 1 USD
              </small>
              </p>

              <p>
              Za účelem sběru finančních prostředků pro tento projekt byl založen zvláštní transparentní účet (veřejná sbírka) pod hlavičkou Muslimské obce v Praze, která je státem registrovanou náboženskou společností.
              </p>

              <p>
                <form action="https://www.paypal.com/donate" method="post" target="_top">
                  <input type="hidden" name="hosted_button_id" value="YFPFLVCNRBMSQ"/>
                  <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button"/>
                  <img alt="" border="0" src="https://www.paypal.com/en_CZ/i/scr/pixel.gif" width="1" height="1"/>
                </form>
              </p>

              <h2>Závěrečné poznámky</h2>
              <p>Při překladu významu Koránu bude upřednostněn obsah před formou, s tím, že forma v překladu opomíjena nebude, jedině pokud by ovlivnila správný obsah.</p>

              <p>Cílem projektu je co nejsprávněji přeložit originál Koránu a vystihnout správný obsah sdělení toho, co nám Alláh říká v originále. Z tohoto důvodu se překladatelé budou snažit používat jasnou současnou češtinu bez archaických výrazů, in šá´Alláh. Věty budou doplněné o vložený tafsír z autentických zdrojů, aby bylo usnadněno čtení a následně chápání textu.</p>

              <p>Nechť Alláh Všemohoucí požehná každému, kdo přispěje na tento projekt, který by měl sloužit potřebám rostoucí česky mluvící muslimské komunity i nemuslimům a zájemcům o islám. Kdokoliv se na této práci podílí, usiluje o přízeň Alláha a má za to velkou odměnu, která bude trvat, dokud tento Korán bude používán ke studiu a in šá´Alláh přivede mnoho lidí k Islámu. Je to sadaqa džárija (sadaqa jaria). Přejme si úspěch a dělejme du´a. In šá´Alláh nám naši práci náš Stvořitel požehná.</p>

              <p>Assalámu alajkum,</p>

              <p>realizační tým.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import * as api from "@/apiList";
  export default {
    components: {
    },
    data() {
      return {
        textLang: 'cs',
      };
    },
    methods: {
      changeTextLang(lang) {
        this.textLang = lang;
      }
    }
  };
</script>
<style lang="scss" scoped>
  $global_color: #4c709b;
  // $global_color: rgba(66, 130, 62, 1);

  p {
    font-size: 0.80rem;
    text-align: justify;
  }

  #columnMain {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;

    .boxTopRight {
      text-align: right;
    }

    #columnMainContent {
      padding: 5px 10px 5px 10px;
      font-size: 12px;
      line-height: 18px;

      #statusContainer {
        position: absolute;
        z-index: 2;
        width: 830px;
        top: 120px;
        margin: 0 auto;
        display: none;

        #status {
          width: 215px;
          padding: 30px;
          border: 2px solid #7EA9D3;
          margin: 0 auto;
          font-size: 16px;
          color: #619AD9;
          font-weight: bold;
          background-image: url('../../assets/images/loadingBox.jpg');
          background-repeat: no-repeat;
        }
      }

      #quranIndex {
        min-height: 580px;
        padding: 5px 0px 0px 0px;

        h2 {
          font-size: 12px;
          font-weight: bold;
          margin: 0px;
        }

        .surahColumn {
          line-height: 30px;
          font-size: 13px;
          font-family: "trebuchet ms", Arial, Helvetica, sans-serif;
          padding: 0px 15px;

          &:first-child {
            padding-left: 0px;
          }

          a {
            .div {
              padding: 10px 10px 10px 10px;
              text-decoration: none;
              color: #666;
              border-bottom: 2px solid transparent;

              &:hover {
                background-color: rgba(192, 192, 192, 0.3);
                // border-bottom: 2px solid rgba(66, 130, 62, 1);
                border-bottom: 2px solid $global_color;
                // color: rgba(66, 130, 62, 1);
                color: $global_color;
              }

              .pl-1 {
                div:first-child {
                  padding-right: 10px;
                }
                div:last-child {
                  padding-left: 10px;
                }
              }
            }
          }

          &:last-child {
            padding-right: 0px;
          }
        }
      }
    }

    .boxBottom {
      // background: url('../assets/images/boxBottom.gif') no-repeat 0px 0px;
      // background-color: #fff;
      height: 4px;
      text-align: right;
      font-size: 0px;
    }

    .giveMeEllipsis {
      white-space: nowrap;
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
    }
  }
</style>